import ArrowButton from '../../../common/button-arrow';

export default ({handleNew, downloadAll}) => (
  <div className="mg-bottom-60 mg-top-10">
    <div className="float-start">
      <ArrowButton
        arrow={false}
        className="float-end"
        onClick={handleNew}
        permissions={{
          action: 'create',
          subjectClass: 'Group',
        }}
        submit={false}
      >
        <i className="fa fa-plus"/>
        {' '}
        New group
      </ArrowButton>
    </div>
    <div className="float-end">
      <ArrowButton
        arrow={false}
        className="float-end"
        onClick={() => downloadAll()}
        permissions={{
          action: 'handle',
          subjectClass: 'Group',
        }}
        submit={false}
      >
        Download All
      </ArrowButton>
    </div>
  </div>
);
